export const ACTIVE_LAYOUT = 'ACTIVE_LAYOUT';
export const ACTIVE_ITEM = 'ACTIVE_ITEM';
export const ACTIVE_SUBMENU = 'ACTIVE_SUBMENU';
